import { Injectable } from "@angular/core";
import { Router, CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot } from "@angular/router";
import { environment } from "src/environments/environment";
import { SessionService } from "./session.service";
import { ModalAuthService } from "./ux/modal-auth.service";

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(
    public session: SessionService,
    public router: Router,
    private authModal: ModalAuthService
  ) {}

  canActivate(route: ActivatedRouteSnapshot,state: RouterStateSnapshot): boolean  {
    let url = state.url;
    if (this.session.isLoggedIn()) {

        if(url.indexOf('/ankesa')> -1){
          return this.allowAnkesa();
        }
        if(url.indexOf('/my-contracts')> -1){
          return this.allowMyContracts();
        }
        if(url.indexOf('/transaction-history')> -1){
          return this.allowTransactionHistory();
        }
        if(url.indexOf('/transfers')> -1){
          return this.allowTransfers();
        }
        if(url.indexOf('/profile/notifications')> -1){
          return this.allowNotification();
        }
        if(url.indexOf('/deposits')> -1){
          return this.allowDeposits();
        }
        if(url.indexOf('/loans')> -1){
          return this.allowLoans();
        }
        if(url.indexOf('/accounts')> -1){
          return this.allowAccounts();
        }
        if(url.indexOf('/transfer')> -1){
          return this.allowTransfer();
        }
        if(url.indexOf('/transfer-history')> -1){
          return this.allowTransferHistory();
        }
        if(url.indexOf('/messages')> -1){
          return this.allowMessages();
        } 
        if(url.indexOf('/branches')> -1){
          return this.allowBranches();
        }
        if(url.indexOf('/postalcodes')> -1){
          return this.allowPostalCodes();
        }
        if(url.indexOf('profile/changepassword')> -1){
          return this.allowChangePassword();
        }
        if(url.indexOf('profile/editprofile')> -1){
          return this.allowEditProfile();
        }
        if(url.indexOf('profile/interface')> -1){
          return this.allowInterface();
        }
        if (url.indexOf('loan-enquire') > -1) {
          return this.allowLoanEnquire();
        }
        if(url.indexOf('/services')> -1){
          return this.allowServices();
        }
        if(url.indexOf('/services/oshee')> -1){
          return this.allowOshee();
        }
        if(url.indexOf('/services/ukt')> -1){
          return this.allowUkt();
        }
        if(url.indexOf('/services/gjoba')> -1){
          return this.allowGjoba();
        }
        if(url.indexOf('/services/one')> -1){
          return this.allowOne();
        }
        if(url.indexOf('/services/albtelecom')> -1){
          return this.allowAlbtelecom();
        }
        if(url.indexOf('/services/kindergarden')> -1){
          return this.allowKindergarden();
        }
        if(url.indexOf('/services/dogana')> -1){
          return this.allowDogana();
        }
        if(url.indexOf('/services/tatime')> -1){
          return this.allowTatime();
        }
        if(url.indexOf('/tracking')> -1){
          return this.allowTracking();
        }
        if(url.indexOf('/register')> -1){
          return this.allowRegister();
        }
        return true;
    }
    if(url.indexOf('/branches')> -1){
      return this.allowBranches();
    }
    if(url.indexOf('/postalcodes')> -1){
      return this.allowPostalCodes();
    }
    if(url.indexOf('/tracking')> -1){
      return this.allowTracking();
    }
    if(url.indexOf('/register')> -1){
      return this.allowRegister();
    }
    this.router.navigate(["/"]);
    this.authModal.open();
    return false;
  }

  allowAnkesa(): boolean {
    if (environment.showAnkesa == true){
      return true;
    }
    return false;
  }

  allowMyContracts(): boolean {
    if (environment.showMyContract == true){
      return true;
    }
    return false;
  }

  allowTransactionHistory(): boolean {
    if (environment.showTransactionHistory == true){
      return true;
    }
    return false;
  }

  allowTransfers(): boolean {
    if (environment.showTransferAnnouncement == true){
      return true;
    }
    return false;
  }

  allowNotification(): boolean {
    if (environment.showNotification == true){
      return true;
    }
    return false;
  }

  allowDeposits(): boolean {
    if (environment.showDeposits == true){
      return true;
    }
    return false;
  }

  allowLoans(): boolean {
    if (environment.showLoans == true){
      return true;
    }
    return false;
  }

  allowAccounts(): boolean {
    if (environment.showAccounts == true){
      return true;
    }
    return false;
  }

  allowTransfer(): boolean {
    if (environment.showTransfers == true){
      return true;
    }
    return false;
  }

  allowTransferHistory(): boolean {
    if (environment.showTransferHistory == true){
      return true;
    }
    return false;
  }

  allowMessages(): boolean {
    if (environment.showMessage == true){
      return true;
    }
    return false;
  }

  allowBranches(): boolean {
    if (environment.showBranches == true){
      return true;
    }
    return false;
  }

  allowPostalCodes(): boolean {
    if (environment.showPostalCode == true){
      return true;
    }
    return false;
  }

  allowChangePassword(): boolean {
    if (environment.showProfileChangePassword == true){
      return true;
    }
    return false;
  }

  allowEditProfile(): boolean {
    if (environment.showProfileEdit == true){
      return true;
    }
    return false;
  }

  allowInterface(): boolean {
    if (environment.showProfileRepresentation == true){
      return true;
    }
    return false;
  }

  allowLoanEnquire(): boolean {
    return !!environment.showLoanEnquire
  }

  allowServices(): boolean {
    if (environment.showService == true){
      return true;
    }
    return false;
  }

  allowOshee(): boolean {
    if (environment.showServiceOSHEE == true){
      return true;
    }
    return false;
  }

  allowUkt(): boolean {
    if (environment.showServiceUK == true){
      return true;
    }
    return false;
  }

  allowGjoba(): boolean {
    if (environment.showServiceGJOBAT == true){
      return true;
    }
    return false;
  }

  allowOne(): boolean {
    if (environment.showServiceONE == true){
      return true;
    }
    return false;
  }

  allowAlbtelecom(): boolean {
    if (environment.showServiceALBTELECOM == true){
      return true;
    }
    return false;
  }

  allowKindergarden(): boolean {
    if (environment.showServiceKOPSHTE == true){
      return true;
    }
    return false;
  }

  allowDogana(): boolean {
    if (environment.showServiceDOGANA == true){
      return true;
    }
    return false;
  }

  allowTatime(): boolean {
    if (environment.showServiceTATIME == true){
      return true;
    }
    return false;
  }

  allowTracking(): boolean {
    if (environment.showTracking == true){
      return true;
    }
    return false;
  }

  allowRegister(): boolean {
    if (environment.showRegister == true){
      return true;
    }
    return false;
  }
}
